import { FsAlert } from "@cof/fs-alert-wc";
import { FsButton } from "@cof/fs-button-wc";
import { FsContainer } from "@cof/fs-container-wc";
import { FsIcon } from "@cof/fs-icon-wc";
import {
  fsFilterAlt16Filled,
  fsSearch16,
  fsLightbulb24,
  fsThumbsUp24,
  fsThumbsDown24,
  fsClose24,
} from "@cof/fs-icons";
import { FsModalDialog, FsModalDialogFooter } from "@cof/fs-modal-dialog-wc";
import { FsTextField } from "@cof/fs-text-field-wc";
import { SafeCustomElements } from "@cof/safe-custom-element-define";
import { FsChoiceButton, FsChoiceButtonGroup } from "@cof/fs-choice-button-wc";
import { FsDivider } from "@cof/fs-divider-wc";
import { FsTooltip } from "@cof/fs-tooltip-wc";
import { FsSkeletonLoader } from "@cof/fs-skeleton-loader-wc";

// https://github-pages.cloud.capitalone.com/fs-design/fsds-web/?path=/docs/getting-started-developers--docs#usage-with-micro-front-ends
// https://github-pages.cloud.capitalone.com/fs-design/fsds-web/?path=/docs/tools-safecustomelementsdefine--docs
const safe = new SafeCustomElements("fd-mfe");

safe.defineMany([
  FsIcon,
  FsTextField,
  FsModalDialog,
  FsModalDialogFooter,
  FsButton,
  FsContainer,
  FsAlert,
  FsChoiceButton,
  FsChoiceButtonGroup,
  FsDivider,
  FsTooltip,
  FsSkeletonLoader,
]);

interface HTMLElementTagNameMap {
  "fd-mfe-icon": FsIcon;
  "fd-mfe-text-field": FsTextField;
  "fd-mfe-modal-dialog": FsModalDialog;
  "fd-mfe-modal-dialog-footer": FsModalDialogFooter;
  "fd-mfe-button": FsButton;
  "fd-mfe-alert": FsAlert;
  "fd-mfe-container": FsContainer;
  "fd-mfe-choice-button": FsChoiceButton;
  "fd-mfe-choice-button-group": FsChoiceButtonGroup;
  "fd-mfe-divider": FsDivider;
  "fd-mfe-tooltip": FsTooltip;
  "fd-mfe-skeleton-loader": FsSkeletonLoader;
}

FsIcon.add([
  fsFilterAlt16Filled,
  fsSearch16,
  fsLightbulb24,
  fsThumbsUp24,
  fsThumbsDown24,
  fsClose24,
]);

declare module "solid-js" {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    type ElementProps<T> = {
      [K in keyof T]: Props<T[K]> & HTMLAttributes<T[K]>;
    };
    type Props<T> = { [K in keyof T as `prop:${string & K}`]?: T[K] };
    interface IntrinsicElements extends ElementProps<HTMLElementTagNameMap> {
      input: InputHTMLAttributes<HTMLInputElement> & {
        "prop:indeterminate"?: boolean;
      };
    }
    interface CustomEvents {
      change: CustomEvent;
      click: MouseEvent;
      transitionend: TransitionEvent;
    }
  }
}
